import { useState, useEffect } from "react";
import queryString from "query-string";

import PaginatedDropdown from "../ReactSelectPaginatedDropdown";

import FilterDropDownStyle from "../DropdownStyle/FilterDropDownStyle";

import { defaultApi } from "../../utils/axiosApi";

import { useTranslation } from "react-i18next";

const getProjectOptions = async (search, prevOptions, page, pageSize, url) => {
  try {
    if (url) {
      const queryParams = { page };
      if (search.trim()) {
        queryParams.name = search;
      }
      const finalUrl = queryString.stringifyUrl({ url, query: queryParams });

      const response = await defaultApi(finalUrl, "GET");
      const { status, data } = response;

      const options = [];
      let hasMore = false;

      if (status === 200 && data && data.results && data.results.length > 0) {
        data.results.forEach((item) => {
          options.push({
            value: item.id,
            label: item.name,
          });
        });
        if (data.next) {
          hasMore = true;
        }
      }
      return { options, hasMore };
    }
  } catch (error) {
    // console.log(error);
    return {
      options: [],
      hasMore: false,
    };
  }
};

const ProjectDropdown = (props) => {
  const { t } = useTranslation();
  const [requestUrl, setRequestUrl] = useState("");
  const {
    selectedOrganization,
    selectedProject,
    selectProject,
    selectedMember,

    placeholder,
    style,
    indicatorIconSize,
    menuPlacement,

    clearable,
    multiple,
  } = props;

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      const url = `${selectedOrganization.id}/projects/short/?active=true`;
      if (selectedMember && selectedMember.id) {
        setRequestUrl(
          queryString.stringifyUrl({
            url,
            query: { user: selectedMember.id },
          })
        );
      } else {
        setRequestUrl(url);
      }
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (requestUrl) {
      if (selectedMember && selectedMember.id) {
        setRequestUrl(
          queryString.stringifyUrl({
            url: requestUrl,
            query: { user: selectedMember.id },
          })
        );
      } else {
        const parsedUrl = queryString.parseUrl(requestUrl);
        setRequestUrl(`${parsedUrl.url}?active=true`);
      }
    }
  }, [selectedMember]);

  return (
    <PaginatedDropdown
      isSearchable
      isClearable={clearable}
      isMulti={multiple}
      menuPlacement={menuPlacement}
      indicatorIconSize={indicatorIconSize}
      placeholder={placeholder || t("select_office")}
      value={selectedProject}
      url={requestUrl}
      getOptions={getProjectOptions}
      onChange={(e) => selectProject(e)}
      styles={style || FilterDropDownStyle({ height: "40px" })}
    />
  );
};

export default ProjectDropdown;
